// Провайлер RHF чтобы данные формы были доступны в компонентах внутри chat
import type { PropsWithChildren } from "react";
import { useForm, FormProvider } from "react-hook-form";
import type { ICampaignWizardForm } from "../../../../../../../shared/types/form.type";
import { createEmptyCampaignWizardForm } from "../components/form/utils/campaign-form-model";

export const CampaignWizardFormProvider = ({ children }: PropsWithChildren) => {
	const formMethods = useForm<ICampaignWizardForm>({
		defaultValues: createEmptyCampaignWizardForm(""),
	});

	return <FormProvider {...formMethods}>{children}</FormProvider>;
};
